import React from 'react';
import Image from 'next/image';
import discordIcon from './images/discord.png';
// import insIcon from './images/ins.png';
import xIcon from './images/x.png';
// import tiktokIcon from './images/tiktok.png';
// import youtubeIcon from './images/youtube.png';
import mailIcon from './images/mail.png';
import styles from './index.module.scss';

interface FooterDemoProps {
  theme?: 'light' | 'dark';
  countryCode: string;
}

/**
 * Footer 设计稿实现（Figma node 27398-30780）
 * 服务端可渲染，支持 light/dark 主题
 */
export default function Footer({ theme = 'dark', countryCode = 'US' }: FooterDemoProps) {
  const mediumList = [
    {
      name: 'Mail',
      icon: mailIcon.src,
      isMail: true,
      url: 'support@roboneo.com',
    },
    {
      name: 'X',
      icon: xIcon.src,
      url: 'https://x.com/RoboNeo_ai',
    },
    {
      name: 'Discord',
      icon: discordIcon.src,
      url: ' https://discord.gg/JXt2gwDpVp',
    },
    // {
    //   name: 'Instagram',
    //   icon: insIcon.src,
    //   url: '',
    // },

    // {
    //   name: 'YouTube',
    //   icon: youtubeIcon.src,
    //   url: '',
    // },
    // {
    //   name: 'TikTok',
    //   icon: tiktokIcon.src,
    //   url: '',
    // },

  ];

  const featureList = [
    {
      text: 'AI Image Editor',
      url: 'https://www.roboneo.com/ai-image-editor',
    },
    {
      text: 'AI Anime Generator',
      url: 'https://www.roboneo.com/ai-anime-generator',
    },
    {
      text: 'AI Poster',
      url: 'https://www.roboneo.com/ai-poster-generator',
    },
    {
      text: 'AI Ad Generator',
      url: 'https://www.roboneo.com/ai-advertising-generator',
    },
    {
      text: 'AI Product Photography',
      url: 'https://www.roboneo.com/ai-product-photography-agent',
    },
  ];

  const imageModelList = [
    {
      text: 'Nano Banana 2',
      url: 'https://www.roboneo.com/nano-banana-2',
    },
    {
      text: 'Gemini 3.1',
      url: 'https://www.roboneo.com/gemini-3-0-image-video-understanding',
    },
    {
      text: 'Flux Knotext',
      url: 'https://www.roboneo.com/flux-kontext-image-editing',
    },
    // {
    //   text: 'Nano Banana Pro',
    //   url: 'https://www.roboneo.com/robonoe-nanobanana2-free',
    // },
  ];

  const videoModelList = [
    {
      text: 'Seedance 2.0',
      url: 'https://www.roboneo.com/seedance2',
    },
    // {
    //   text: 'Kling 2.5',
    //   url: 'https://www.roboneo.com/kling-video-generator',
    // },
    {
      text: 'Kling 3.0',
      url: 'https://www.roboneo.com/kling-3',
    },
    {
      text: 'Sora 2',
      url: 'https://www.roboneo.com/roboneo-sora2-video-generator',
    },
    {
      text: 'VEO 3.0',
      url: 'https://www.roboneo.com/veo3-video-generator',
    },
    {
      text: 'Wan 2.6',
      url: 'https://www.roboneo.com/wan-video-generator2',
    },
  ];

  const helpLegalList = [
    {
      text: 'Help Center',
      url: 'https://www.notion.so/cpp-roboneo/RoboNeo-Playbook-2a024b73201880ef886afdeb4864b7d0',
    },
    {
      text: 'Terms of Service',
      url: `https://www.roboneo.com/user-agreement?countryCode=${countryCode}&theme=dark`,
    },
    {
      text: 'Privacy Policy',
      url: `https://www.roboneo.com/privacy-policy?countryCode=${countryCode}&theme=dark`,
    },
  ];

  return (
    <footer className={styles.footer} data-theme={theme}>
      <div className={styles.container}>
        <div className={styles.main}>
          <div className={styles.brand}>
            <div className={styles.logo} />
            <p className={styles.description}>
              AI Video Generator
            </p>
            {/* 社媒列表 */}
            <ul className={styles.mediumList}>
              {mediumList.map((item) => (
                <li key={item.name}>
                  <a href={item.isMail ? `mailto:${item.url}` : item.url} title={item.name} target={item.isMail ? '_self' : '_blank'} rel="noopener noreferrer">
                    <Image src={item.icon} alt={item.name} width={36} height={36} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.links}>
            <div className={styles.linkGroup}>
              <h4 className={styles.groupTitle}>Help & Legal</h4>
              <ul className={styles.linkList}>
                {helpLegalList.map((item) => (
                  <li key={item.text}>
                    <a href={item.url} rel="nofollow noreferrer" target="_blank">{item.text}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.linkGroup}>
              <h4 className={styles.groupTitle}>Features</h4>
              <ul className={styles.linkList}>
                {featureList.map((item) => (
                  <li key={item.text}>
                    <a href={item.url} rel="nofollow noreferrer" target="_blank">{item.text}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.linkGroup}>
              <h4 className={styles.groupTitle}>Image Models</h4>
              <ul className={styles.linkList}>
                {imageModelList.map((item) => (
                  <li key={item.text}>
                    <a href={item.url} rel="nofollow noreferrer" target="_blank">{item.text}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.linkGroup}>
              <h4 className={styles.groupTitle}>Video Models</h4>
              <ul className={styles.linkList}>
                {videoModelList.map((item) => (
                  <li key={item.text}>
                    <a href={item.url} rel="nofollow noreferrer" target="_blank">{item.text}</a>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            Copyright © 2026 Meitu Technology Pty Ltd
          </p>
        </div>
      </div>
    </footer>
  );
}
